import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Bt = {},
    ye = function ye(t, e, r, a, n) {
  var i = new Worker(Bt[e] || (Bt[e] = URL.createObjectURL(new Blob([t + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'], {
    type: "text/javascript"
  }))));
  return i.onmessage = function (s) {
    var u = s.data,
        c = u.$e$;

    if (c) {
      var o = new Error(c[0]);
      o.code = c[1], o.stack = c[2], n(o, null);
    } else n(null, u);
  }, i.postMessage(r, a), i;
},
    z = Uint8Array,
    J = Uint16Array,
    kt = Int32Array,
    At = new z([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]),
    bt = new z([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]),
    Ct = new z([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]),
    qt = function qt(t, e) {
  for (var r = new J(31), a = 0; a < 31; ++a) {
    r[a] = e += 1 << t[a - 1];
  }

  for (var n = new kt(r[30]), a = 1; a < 30; ++a) {
    for (var i = r[a]; i < r[a + 1]; ++i) {
      n[i] = i - r[a] << 5 | a;
    }
  }

  return {
    b: r,
    r: n
  };
},
    Rt = qt(At, 2),
    It = Rt.b,
    ge = Rt.r;

It[28] = 258, ge[258] = 28;
var $t = qt(bt, 0),
    Ht = $t.b,
    ot = new J(32768);

for (_ = 0; _ < 32768; ++_) {
  R = (_ & 43690) >> 1 | (_ & 21845) << 1, R = (R & 52428) >> 2 | (R & 13107) << 2, R = (R & 61680) >> 4 | (R & 3855) << 4, ot[_] = ((R & 65280) >> 8 | (R & 255) << 8) >> 1;
}

var R,
    _,
    K = function K(t, e, r) {
  for (var a = t.length, n = 0, i = new J(e); n < a; ++n) {
    t[n] && ++i[t[n] - 1];
  }

  var s = new J(e);

  for (n = 1; n < e; ++n) {
    s[n] = s[n - 1] + i[n - 1] << 1;
  }

  var u;

  if (r) {
    u = new J(1 << e);
    var c = 15 - e;

    for (n = 0; n < a; ++n) {
      if (t[n]) for (var o = n << 4 | t[n], l = e - t[n], f = s[t[n] - 1]++ << l, h = f | (1 << l) - 1; f <= h; ++f) {
        u[ot[f] >> c] = o;
      }
    }
  } else for (u = new J(a), n = 0; n < a; ++n) {
    t[n] && (u[n] = ot[s[t[n] - 1]++] >> 15 - t[n]);
  }

  return u;
},
    et = new z(288);

for (_ = 0; _ < 144; ++_) {
  et[_] = 8;
}

var _;

for (_ = 144; _ < 256; ++_) {
  et[_] = 9;
}

var _;

for (_ = 256; _ < 280; ++_) {
  et[_] = 7;
}

var _;

for (_ = 280; _ < 288; ++_) {
  et[_] = 8;
}

var _,
    Jt = new z(32);

for (_ = 0; _ < 32; ++_) {
  Jt[_] = 5;
}

var _;

var Wt = K(et, 9, 1);

var Gt = K(Jt, 5, 1),
    it = function it(t) {
  for (var e = t[0], r = 1; r < t.length; ++r) {
    t[r] > e && (e = t[r]);
  }

  return e;
},
    L = function L(t, e, r) {
  var a = e / 8 | 0;
  return (t[a] | t[a + 1] << 8) >> (e & 7) & r;
},
    st = function st(t, e) {
  var r = e / 8 | 0;
  return (t[r] | t[r + 1] << 8 | t[r + 2] << 16) >> (e & 7);
},
    Zt = function Zt(t) {
  return (t + 7) / 8 | 0;
},
    ut = function ut(t, e, r) {
  (e == null || e < 0) && (e = 0), (r == null || r > t.length) && (r = t.length);
  var a = new z(r - e);
  return a.set(t.subarray(e, r)), a;
};

var Kt = ["unexpected EOF", "invalid block type", "invalid length/literal", "invalid distance", "stream finished", "no stream handler",, "no callback", "invalid UTF-8 data", "extra field too long", "date not in range 1980-2099", "filename too long", "stream finishing", "invalid zip data"],
    E = function E(t, e, r) {
  var a = new Error(e || Kt[t]);
  if (a.code = t, Error.captureStackTrace && Error.captureStackTrace(a, E), !r) throw a;
  return a;
},
    Yt = function Yt(t, e, r, a) {
  var n = t.length,
      i = a ? a.length : 0;
  if (!n || e.f && !e.l) return r || new z(0);
  var s = !r || e.i != 2,
      u = e.i;
  r || (r = new z(n * 3));

  var c = function c(Lt) {
    var Ut = r.length;

    if (Lt > Ut) {
      var Ft = new z(Math.max(Ut * 2, Lt));
      Ft.set(r), r = Ft;
    }
  },
      o = e.f || 0,
      l = e.p || 0,
      f = e.b || 0,
      h = e.l,
      p = e.d,
      m = e.m,
      d = e.n,
      y = n * 8;

  do {
    if (!h) {
      o = L(t, l, 1);
      var v = L(t, l + 1, 3);
      if (l += 3, v) {
        if (v == 1) h = Wt, p = Gt, m = 9, d = 5;else if (v == 2) {
          var M = L(t, l, 31) + 257,
              $ = L(t, l + 10, 15) + 4,
              j = M + L(t, l + 5, 31) + 1;
          l += 14;

          for (var T = new z(j), N = new z(19), I = 0; I < $; ++I) {
            N[Ct[I]] = L(t, l + I * 3, 7);
          }

          l += $ * 3;

          for (var S = it(N), V = (1 << S) - 1, pt = K(N, S, 1), I = 0; I < j;) {
            var Q = pt[L(t, l, V)];
            l += Q & 15;
            var g = Q >> 4;
            if (g < 16) T[I++] = g;else {
              var x = 0,
                  k = 0;

              for (g == 16 ? (k = 3 + L(t, l, 3), l += 2, x = T[I - 1]) : g == 17 ? (k = 3 + L(t, l, 7), l += 3) : g == 18 && (k = 11 + L(t, l, 127), l += 7); k--;) {
                T[I++] = x;
              }
            }
          }

          var Tt = T.subarray(0, M),
              F = T.subarray(M);
          m = it(Tt), d = it(F), h = K(Tt, m, 1), p = K(F, d, 1);
        } else E(1);
      } else {
        var g = Zt(l) + 4,
            A = t[g - 4] | t[g - 3] << 8,
            D = g + A;

        if (D > n) {
          u && E(0);
          break;
        }

        s && c(f + A), r.set(t.subarray(g, D), f), e.b = f += A, e.p = l = D * 8, e.f = o;
        continue;
      }

      if (l > y) {
        u && E(0);
        break;
      }
    }

    s && c(f + 131072);

    for (var pe = (1 << m) - 1, me = (1 << d) - 1, mt = l;; mt = l) {
      var x = h[st(t, l) & pe],
          Z = x >> 4;

      if (l += x & 15, l > y) {
        u && E(0);
        break;
      }

      if (x || E(2), Z < 256) r[f++] = Z;else if (Z == 256) {
        mt = l, h = null;
        break;
      } else {
        var Nt = Z - 254;

        if (Z > 264) {
          var I = Z - 257,
              tt = At[I];
          Nt = L(t, l, (1 << tt) - 1) + It[I], l += tt;
        }

        var vt = p[st(t, l) & me],
            yt = vt >> 4;
        vt || E(3), l += vt & 15;
        var F = Ht[yt];

        if (yt > 3) {
          var tt = bt[yt];
          F += st(t, l) & (1 << tt) - 1, l += tt;
        }

        if (l > y) {
          u && E(0);
          break;
        }

        s && c(f + 131072);
        var gt = f + Nt;

        if (f < F) {
          var jt = i - F,
              ve = Math.min(F, gt);

          for (jt + f < 0 && E(3); f < ve; ++f) {
            r[f] = a[jt + f];
          }
        }

        for (; f < gt; f += 4) {
          r[f] = r[f - F], r[f + 1] = r[f + 1 - F], r[f + 2] = r[f + 2 - F], r[f + 3] = r[f + 3 - F];
        }

        f = gt;
      }
    }

    e.l = h, e.p = mt, e.b = f, e.f = o, h && (o = 1, e.m = m, e.d = p, e.n = d);
  } while (!o);

  return f == r.length ? r : ut(r, 0, f);
};

var _e = new z(0);

var we = function we(t, e) {
  var r = {};

  for (var a in t) {
    r[a] = t[a];
  }

  for (var a in e) {
    r[a] = e[a];
  }

  return r;
},
    Pt = function Pt(t, e, r) {
  for (var a = t(), n = t.toString(), i = n.slice(n.indexOf("[") + 1, n.lastIndexOf("]")).replace(/\s+/g, "").split(","), s = 0; s < a.length; ++s) {
    var u = a[s],
        c = i[s];

    if (typeof u == "function") {
      e += ";" + c + "=";
      var o = u.toString();
      if (u.prototype) {
        if (o.indexOf("[native code]") != -1) {
          var l = o.indexOf(" ", 8) + 1;
          e += o.slice(l, o.indexOf("(", l));
        } else {
          e += o;

          for (var f in u.prototype) {
            e += ";" + c + ".prototype." + f + "=" + u.prototype[f].toString();
          }
        }
      } else e += o;
    } else r[c] = u;
  }

  return e;
},
    at = [],
    Ae = function Ae(t) {
  var e = [];

  for (var r in t) {
    t[r].buffer && e.push((t[r] = new t[r].constructor(t[r])).buffer);
  }

  return e;
},
    be = function be(t, e, r, a) {
  if (!at[r]) {
    for (var n = "", i = {}, s = t.length - 1, u = 0; u < s; ++u) {
      n = Pt(t[u], n, i);
    }

    at[r] = {
      c: Pt(t[s], n, i),
      e: i
    };
  }

  var c = we({}, at[r].e);
  return ye(at[r].c + ";onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=" + e.toString() + "}", r, c, Ae(c), a);
},
    Ie = function Ie() {
  return [z, J, kt, At, bt, Ct, It, Ht, Wt, Gt, ot, Kt, K, it, L, st, Zt, ut, E, Yt, xt, Xt, Qt];
};

var Xt = function Xt(t) {
  return postMessage(t, [t.buffer]);
},
    Qt = function Qt(t) {
  return t && {
    out: t.size && new z(t.size),
    dictionary: t.dictionary
  };
},
    xe = function xe(t, e, r, a, n, i) {
  var s = be(r, a, n, function (u, c) {
    s.terminate(), i(u, c);
  });
  return s.postMessage([t, e], e.consume ? [t.buffer] : []), function () {
    s.terminate();
  };
};

var C = function C(t, e) {
  return t[e] | t[e + 1] << 8;
},
    B = function B(t, e) {
  return (t[e] | t[e + 1] << 8 | t[e + 2] << 16 | t[e + 3] << 24) >>> 0;
},
    _t = function _t(t, e) {
  return B(t, e) + B(t, e + 4) * 4294967296;
};

function Ee(t, e, r) {
  return r || (r = e, e = {}), typeof r != "function" && E(7), xe(t, e, [Ie], function (a) {
    return Xt(xt(a.data[0], Qt(a.data[1])));
  }, 1, r);
}

function xt(t, e) {
  return Yt(t, {
    i: 2
  }, e && e.out, e && e.dictionary);
}

var wt = typeof TextDecoder < "u" && new TextDecoder(),
    ze = 0;

try {
  wt.decode(_e, {
    stream: !0
  }), ze = 1;
} catch (_unused) {}

var Oe = function Oe(t) {
  for (var e = "", r = 0;;) {
    var a = t[r++],
        n = (a > 127) + (a > 223) + (a > 239);
    if (r + n > t.length) return {
      s: e,
      r: ut(t, r - 1)
    };
    n ? n == 3 ? (a = ((a & 15) << 18 | (t[r++] & 63) << 12 | (t[r++] & 63) << 6 | t[r++] & 63) - 65536, e += String.fromCharCode(55296 | a >> 10, 56320 | a & 1023)) : n & 1 ? e += String.fromCharCode((a & 31) << 6 | t[r++] & 63) : e += String.fromCharCode((a & 15) << 12 | (t[r++] & 63) << 6 | t[r++] & 63) : e += String.fromCharCode(a);
  }
};

function W(t, e) {
  if (e) {
    for (var r = "", a = 0; a < t.length; a += 16384) {
      r += String.fromCharCode.apply(null, t.subarray(a, a + 16384));
    }

    return r;
  } else {
    if (wt) return wt.decode(t);
    var n = Oe(t),
        i = n.s,
        r = n.r;
    return r.length && E(8), i;
  }
}

var Me = function Me(t, e) {
  return e + 30 + C(t, e + 26) + C(t, e + 28);
},
    Se = function Se(t, e, r) {
  var a = C(t, e + 28),
      n = W(t.subarray(e + 46, e + 46 + a), !(C(t, e + 8) & 2048)),
      i = e + 46 + a,
      s = B(t, e + 20),
      u = r && s == 4294967295 ? De(t, i) : [s, B(t, e + 24), B(t, e + 42)],
      c = u[0],
      o = u[1],
      l = u[2];
  return [C(t, e + 10), c, o, n, i + C(t, e + 30) + C(t, e + 32), l];
},
    De = function De(t, e) {
  for (; C(t, e) != 1; e += 4 + C(t, e + 2)) {
    ;
  }

  return [_t(t, e + 12), _t(t, e + 4), _t(t, e + 20)];
};

var Vt = typeof queueMicrotask == "function" ? queueMicrotask : typeof setTimeout == "function" ? setTimeout : function (t) {
  t();
};

function te(t, e, r) {
  r || (r = e, e = {}), typeof r != "function" && E(7);

  var a = [],
      n = function n() {
    for (var y = 0; y < a.length; ++y) {
      a[y]();
    }
  },
      i = {},
      s = function s(y, v) {
    Vt(function () {
      r(y, v);
    });
  };

  Vt(function () {
    s = r;
  });

  for (var u = t.length - 22; B(t, u) != 101010256; --u) {
    if (!u || t.length - u > 65558) return s(E(13, 0, 1), null), n;
  }

  var c = C(t, u + 8);

  if (c) {
    var o = c,
        l = B(t, u + 16),
        f = l == 4294967295 || o == 65535;

    if (f) {
      var h = B(t, u - 12);
      f = B(t, h) == 101075792, f && (o = c = B(t, h + 32), l = B(t, h + 48));
    }

    for (var p = e && e.filter, m = function m(y) {
      var v = Se(t, l, f),
          g = v[0],
          A = v[1],
          D = v[2],
          M = v[3],
          $ = v[4],
          j = v[5],
          T = Me(t, j);
      l = $;

      var N = function N(S, V) {
        S ? (n(), s(S, null)) : (V && (i[M] = V), --c || s(null, i));
      };

      if (!p || p({
        name: M,
        size: A,
        originalSize: D,
        compression: g
      })) {
        if (!g) N(null, ut(t, T, T + A));else if (g == 8) {
          var I = t.subarray(T, T + A);
          if (A < 32e4) try {
            N(null, xt(I, {
              out: new z(D)
            }));
          } catch (S) {
            N(S, null);
          } else a.push(Ee(I, {
            size: D
          }, N));
        } else N(E(14, "unknown compression type " + g, 1), null);
      } else N(null, null);
    }, d = 0; d < o; ++d) {
      m(d);
    }
  } else s(null, {});

  return n;
}

function ee(t) {
  return (Array.isArray(t) ? t : t.issues).reduce(function (e, r) {
    if (r.path) {
      var a = r.path.map(function (_ref) {
        var n = _ref.key;
        return n;
      }).join(".");
      e.nested[a] = [].concat(_toConsumableArray(e.nested[a] || []), [r.message]);
    } else e.root = [].concat(_toConsumableArray(e.root || []), [r.message]);

    return e;
  }, {
    nested: {}
  });
}

var Te = /*#__PURE__*/function (_Error) {
  _inherits(Te, _Error);

  var _super = _createSuper(Te);

  function Te(t) {
    var _this;

    _classCallCheck(this, Te);

    (_this = _super.call(this, t[0].message), _defineProperty(_assertThisInitialized(_this), "issues", void 0)), _this.name = "ValiError", _this.issues = t;
    return _this;
  }

  return _createClass(Te);
}( /*#__PURE__*/_wrapNativeSuper(Error));

function Ne(t, e) {
  return {
    reason: t == null ? void 0 : t.reason,
    validation: e.validation,
    origin: (t == null ? void 0 : t.origin) || "value",
    message: e.message,
    input: e.input,
    abortEarly: t == null ? void 0 : t.abortEarly,
    abortPipeEarly: t == null ? void 0 : t.abortPipeEarly
  };
}

function je(t, e) {
  return {
    reason: e,
    origin: t == null ? void 0 : t.origin,
    abortEarly: t == null ? void 0 : t.abortEarly,
    abortPipeEarly: t == null ? void 0 : t.abortPipeEarly
  };
}

function H(t, e, r, a) {
  if (!e || !e.length) return {
    output: t
  };
  var n,
      i,
      s = t;

  var _iterator = _createForOfIteratorHelper(e),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var u = _step.value;
      var c = u(s);

      if (c.issue) {
        n = n || je(r, a);
        var o = Ne(n, c.issue);
        if (i ? i.push(o) : i = [o], n.abortEarly || n.abortPipeEarly) break;
      } else s = c.output;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return i ? {
    issues: i
  } : {
    output: s
  };
}

function P(t, e) {
  return !t || typeof t == "string" ? [t, e] : [void 0, t];
}

function q(t, e, r, a, n, i) {
  return {
    issues: [{
      reason: e,
      validation: r,
      origin: (t == null ? void 0 : t.origin) || "value",
      message: a,
      input: n,
      issues: i,
      abortEarly: t == null ? void 0 : t.abortEarly,
      abortPipeEarly: t == null ? void 0 : t.abortPipeEarly
    }]
  };
}

function re() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return {
    schema: "any",
    async: !1,
    _parse: function _parse(e, r) {
      return H(e, t, r, "any");
    }
  };
}

function Y(t, e, r) {
  var _P = P(e, r),
      _P2 = _slicedToArray(_P, 2),
      a = _P2[0],
      n = _P2[1];

  return {
    schema: "array",
    array: {
      item: t
    },
    async: !1,
    _parse: function _parse(i, s) {
      if (!Array.isArray(i)) return q(s, "type", "array", a || "Invalid type", i);
      var u,
          c = [];

      for (var o = 0; o < i.length; o++) {
        var l = i[o],
            f = t._parse(l, s);

        if (f.issues) {
          var h = {
            schema: "array",
            input: i,
            key: o,
            value: l
          };

          var _iterator2 = _createForOfIteratorHelper(f.issues),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var p = _step2.value;
              p.path ? p.path.unshift(h) : p.path = [h], u == null || u.push(p);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          if (u || (u = f.issues), s != null && s.abortEarly) break;
        } else c.push(f.output);
      }

      return u ? {
        issues: u
      } : H(c, n, s, "array");
    }
  };
}

function lt(t, e) {
  var _P3 = P(t, e),
      _P4 = _slicedToArray(_P3, 2),
      r = _P4[0],
      a = _P4[1];

  return {
    schema: "boolean",
    async: !1,
    _parse: function _parse(n, i) {
      return typeof n != "boolean" ? q(i, "type", "boolean", r || "Invalid type", n) : H(n, a, i, "boolean");
    }
  };
}

function Et(t, e) {
  return {
    schema: "literal",
    literal: t,
    async: !1,
    _parse: function _parse(r, a) {
      return r !== t ? q(a, "type", "literal", e || "Invalid type", r) : {
        output: r
      };
    }
  };
}

function ne(t, e) {
  return {
    schema: "native_enum",
    nativeEnum: t,
    async: !1,
    _parse: function _parse(r, a) {
      return Object.values(t).includes(r) ? {
        output: r
      } : q(a, "type", "native_enum", e || "Invalid type", r);
    }
  };
}

function U(t, e) {
  var _P5 = P(t, e),
      _P6 = _slicedToArray(_P5, 2),
      r = _P6[0],
      a = _P6[1];

  return {
    schema: "number",
    async: !1,
    _parse: function _parse(n, i) {
      return typeof n != "number" ? q(i, "type", "number", r || "Invalid type", n) : H(n, a, i, "number");
    }
  };
}

function O(t, e, r) {
  var _P7 = P(e, r),
      _P8 = _slicedToArray(_P7, 2),
      a = _P8[0],
      n = _P8[1],
      i;

  return {
    schema: "object",
    object: t,
    async: !1,
    _parse: function _parse(s, u) {
      if (!s || typeof s != "object") return q(u, "type", "object", a || "Invalid type", s);
      i = i || Object.entries(t);
      var c,
          o = {};

      var _iterator3 = _createForOfIteratorHelper(i),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
              l = _step3$value[0],
              f = _step3$value[1];

          var h = s[l],
              p = f._parse(h, u);

          if (p.issues) {
            var m = {
              schema: "object",
              input: s,
              key: l,
              value: h
            };

            var _iterator4 = _createForOfIteratorHelper(p.issues),
                _step4;

            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var d = _step4.value;
                d.path ? d.path.unshift(m) : d.path = [m], c == null || c.push(d);
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }

            if (c || (c = p.issues), u != null && u.abortEarly) break;
          } else o[l] = p.output;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return c ? {
        issues: c
      } : H(o, n, u, "object");
    }
  };
}

function w(t) {
  return {
    schema: "optional",
    wrapped: t,
    async: !1,
    _parse: function _parse(e, r) {
      return e === void 0 ? {
        output: e
      } : t._parse(e, r);
    }
  };
}

function b(t, e) {
  var _P9 = P(t, e),
      _P10 = _slicedToArray(_P9, 2),
      r = _P10[0],
      a = _P10[1];

  return {
    schema: "string",
    async: !1,
    _parse: function _parse(n, i) {
      return typeof n != "string" ? q(i, "type", "string", r || "Invalid type", n) : H(n, a, i, "string");
    }
  };
}

function Le(t, e, r, a) {
  if (typeof e == "object" && !Array.isArray(e)) {
    var _P11 = P(r, a),
        _P12 = _slicedToArray(_P11, 2),
        s = _P12[0],
        u = _P12[1];

    return [t, e, s, u];
  }

  var _P13 = P(e, r),
      _P14 = _slicedToArray(_P13, 2),
      n = _P14[0],
      i = _P14[1];

  return [b(), t, n, i];
}

var Ue = ["__proto__", "prototype", "constructor"];

function zt(t, e, r, a) {
  var _Le = Le(t, e, r, a),
      _Le2 = _slicedToArray(_Le, 4),
      n = _Le2[0],
      i = _Le2[1],
      s = _Le2[2],
      u = _Le2[3];

  return {
    schema: "record",
    record: {
      key: n,
      value: i
    },
    async: !1,
    _parse: function _parse(c, o) {
      if (!c || typeof c != "object") return q(o, "type", "record", s || "Invalid type", c);
      var l,
          f = {};

      for (var _i = 0, _Object$entries = Object.entries(c); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            h = _Object$entries$_i[0],
            p = _Object$entries$_i[1];

        if (!Ue.includes(h)) {
          var m = void 0,
              d = n._parse(h, {
            origin: "key",
            abortEarly: o == null ? void 0 : o.abortEarly,
            abortPipeEarly: o == null ? void 0 : o.abortPipeEarly
          });

          if (d.issues) {
            m = {
              schema: "record",
              input: c,
              key: h,
              value: p
            };

            var _iterator5 = _createForOfIteratorHelper(d.issues),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var v = _step5.value;
                v.path = [m], l == null || l.push(v);
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }

            if (l || (l = d.issues), o != null && o.abortEarly) break;
          }

          var y = i._parse(p, o);

          if (y.issues) {
            m = m || {
              schema: "record",
              input: c,
              key: h,
              value: p
            };

            var _iterator6 = _createForOfIteratorHelper(y.issues),
                _step6;

            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var _v = _step6.value;
                _v.path ? _v.path.unshift(m) : _v.path = [m], l == null || l.push(_v);
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }

            if (l || (l = y.issues), o != null && o.abortEarly) break;
          }

          !d.issues && !y.issues && (f[d.output] = y.output);
        }
      }

      return l ? {
        issues: l
      } : H(f, u, o, "record");
    }
  };
}

function Fe(t, e, r) {
  if (typeof t == "object" && !Array.isArray(t)) {
    var _P15 = P(e, r),
        _P16 = _slicedToArray(_P15, 2),
        i = _P16[0],
        s = _P16[1];

    return [t, i, s];
  }

  var _P17 = P(t, e),
      _P18 = _slicedToArray(_P17, 2),
      a = _P18[0],
      n = _P18[1];

  return [void 0, a, n];
}

function Ot(t, e, r, a) {
  var _Fe = Fe(e, r, a),
      _Fe2 = _slicedToArray(_Fe, 3),
      n = _Fe2[0],
      i = _Fe2[1],
      s = _Fe2[2];

  return {
    schema: "tuple",
    tuple: {
      items: t,
      rest: n
    },
    async: !1,
    _parse: function _parse(u, c) {
      if (!Array.isArray(u) || !n && t.length !== u.length || n && t.length > u.length) return q(c, "type", "tuple", i || "Invalid type", u);
      var o,
          l = [];

      for (var f = 0; f < t.length; f++) {
        var h = u[f],
            p = t[f]._parse(h, c);

        if (p.issues) {
          var m = {
            schema: "tuple",
            input: u,
            key: f,
            value: h
          };

          var _iterator7 = _createForOfIteratorHelper(p.issues),
              _step7;

          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var d = _step7.value;
              d.path ? d.path.unshift(m) : d.path = [m], o == null || o.push(d);
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }

          if (o || (o = p.issues), c != null && c.abortEarly) break;
        } else l[f] = p.output;
      }

      if (n) for (var _f = t.length; _f < u.length; _f++) {
        var _h = u[_f],
            _p = n._parse(_h, c);

        if (_p.issues) {
          var _m = {
            schema: "tuple",
            input: u,
            key: _f,
            value: _h
          };

          var _iterator8 = _createForOfIteratorHelper(_p.issues),
              _step8;

          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var _d = _step8.value;
              _d.path ? _d.path.unshift(_m) : _d.path = [_m], o == null || o.push(_d);
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }

          if (o || (o = _p.issues), c != null && c.abortEarly) break;
        } else l[_f] = _p.output;
      }
      return o ? {
        issues: o
      } : H(l, s, c, "tuple");
    }
  };
}

function ct(t, e) {
  return {
    schema: "union",
    union: t,
    async: !1,
    _parse: function _parse(r, a) {
      var n, i;

      var _iterator9 = _createForOfIteratorHelper(t),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var s = _step9.value;

          var u = s._parse(r, a);

          if (u.issues) {
            if (n) {
              var _iterator10 = _createForOfIteratorHelper(u.issues),
                  _step10;

              try {
                for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                  var c = _step10.value;
                  n.push(c);
                }
              } catch (err) {
                _iterator10.e(err);
              } finally {
                _iterator10.f();
              }
            } else n = u.issues;
          } else {
            i = [u.output];
            break;
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      return i ? {
        output: i[0]
      } : q(a, "type", "union", e || "Invalid type", r, n);
    }
  };
}

function X(t, e, r) {
  var _P19 = P(e, r),
      _P20 = _slicedToArray(_P19, 2),
      a = _P20[0],
      n = _P20[1];

  return O(t.reduce(function (i, s) {
    return _objectSpread(_objectSpread({}, i), s.object);
  }, {}), a, n);
}

function ae(t, e, r, a) {
  var _P21 = P(r, a),
      _P22 = _slicedToArray(_P21, 2),
      n = _P22[0],
      i = _P22[1];

  return O(Object.entries(t.object).reduce(function (s, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        u = _ref3[0],
        c = _ref3[1];

    return e.includes(u) ? s : _objectSpread(_objectSpread({}, s), {}, _defineProperty({}, u, c));
  }, {}), n, i);
}

function ie(t, e, r) {
  var a = t._parse(e, r);

  return a.issues ? {
    success: !1,
    error: new Te(a.issues),
    issues: a.issues
  } : {
    success: !0,
    data: a.output,
    output: a.output
  };
}

function ft(t, e) {
  return function (r) {
    return r > t ? {
      issue: {
        validation: "max_value",
        message: e || "Invalid value",
        input: r
      }
    } : {
      output: r
    };
  };
}

function ht(t, e) {
  return function (r) {
    return r < t ? {
      issue: {
        validation: "min_value",
        message: e || "Invalid value",
        input: r
      }
    } : {
      output: r
    };
  };
}

var Be = Object.create,
    Mt = Object.defineProperty,
    Pe = Object.getOwnPropertyDescriptor,
    ce = Object.getOwnPropertyNames,
    Ve = Object.getPrototypeOf,
    ke = Object.prototype.hasOwnProperty,
    Ce = function Ce(t, e, r) {
  return e in t ? Mt(t, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : t[e] = r;
},
    rt = function rt(t, e) {
  return function () {
    return e || (0, t[ce(t)[0]])((e = {
      exports: {}
    }).exports, e), e.exports;
  };
},
    qe = function qe(t, e, r, a) {
  if (e && typeof e == "object" || typeof e == "function") {
    var _iterator11 = _createForOfIteratorHelper(ce(e)),
        _step11;

    try {
      var _loop = function _loop() {
        var n = _step11.value;
        !ke.call(t, n) && n !== r && Mt(t, n, {
          get: function get() {
            return e[n];
          },
          enumerable: !(a = Pe(e, n)) || a.enumerable
        });
      };

      for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator11.e(err);
    } finally {
      _iterator11.f();
    }
  }

  return t;
},
    Re = function Re(t, e, r) {
  return r = t != null ? Be(Ve(t)) : {}, qe(e || !t || !t.__esModule ? Mt(r, "default", {
    value: t,
    enumerable: !0
  }) : r, t);
},
    $e = function $e(t, e, r) {
  return Ce(t, typeof e != "symbol" ? e + "" : e, r), r;
},
    He = rt({
  "../../node_modules/.pnpm/@rgba-image+copy@0.1.3/node_modules/@rgba-image/copy/dist/index.js": function node_modulesPnpmRgbaImageCopy013Node_modulesRgbaImageCopyDistIndexJs(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.copy = void 0;

    var e = function e(r, a) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : r.width - n;
      var u = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : r.height - i;
      var c = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
      var o = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
      if (n = n | 0, i = i | 0, s = s | 0, u = u | 0, c = c | 0, o = o | 0, s <= 0 || u <= 0) return;
      var l = new Uint32Array(r.data.buffer),
          f = new Uint32Array(a.data.buffer);

      for (var h = 0; h < u; h++) {
        var p = i + h;
        if (p < 0 || p >= r.height) continue;
        var m = o + h;
        if (!(m < 0 || m >= a.height)) for (var d = 0; d < s; d++) {
          var y = n + d;
          if (y < 0 || y >= r.width) continue;
          var v = c + d;
          if (v < 0 || v >= a.width) continue;
          var g = p * r.width + y,
              A = m * a.width + v;
          f[A] = l[g];
        }
      }
    };

    t.copy = e;
  }
}),
    Je = rt({
  "../../node_modules/.pnpm/@rgba-image+create-image@0.1.1/node_modules/@rgba-image/create-image/dist/index.js": function node_modulesPnpmRgbaImageCreateImage011Node_modulesRgbaImageCreateImageDistIndexJs(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CreateImageFactory = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0, 0, 0, 0];
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
      if (r = Math.floor(r), isNaN(r) || r < 1) throw TypeError("channels should be a positive non-zero number");
      if (!("length" in e) || e.length < r) throw TypeError("fill should be iterable with at least ".concat(r, " members"));
      e = new Uint8ClampedArray(e).slice(0, r);
      var a = e.every(function (i) {
        return i === 0;
      });
      return function (i, s, u) {
        if (i === void 0 || s === void 0) throw TypeError("Not enough arguments");
        if (i = Math.floor(i), s = Math.floor(s), isNaN(i) || i < 1 || isNaN(s) || s < 1) throw TypeError("Index or size is negative or greater than the allowed amount");
        var c = i * s * r;

        if (u === void 0 && (u = new Uint8ClampedArray(c)), u instanceof Uint8ClampedArray) {
          if (u.length !== c) throw TypeError("Index or size is negative or greater than the allowed amount");
          if (!a) for (var o = 0; o < s; o++) {
            for (var l = 0; l < i; l++) {
              var f = (o * i + l) * r;

              for (var h = 0; h < r; h++) {
                u[f + h] = e[h];
              }
            }
          }
          return {
            get width() {
              return i;
            },

            get height() {
              return s;
            },

            get data() {
              return u;
            }

          };
        }

        throw TypeError("Expected data to be Uint8ClampedArray or undefined");
      };
    }, t.createImage = t.CreateImageFactory();
  }
}),
    We = rt({
  "../../node_modules/.pnpm/@rgba-image+lanczos@0.1.1/node_modules/@rgba-image/lanczos/dist/filters.js": function node_modulesPnpmRgbaImageLanczos011Node_modulesRgbaImageLanczosDistFiltersJs(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.filters = void 0;

    var e = 14,
        r = function r(i, s) {
      if (i <= -s || i >= s || i == 0) return 0;
      var u = i * Math.PI;
      return Math.sin(u) / u * Math.sin(u / s) / (u / s);
    },
        a = function a(i) {
      return Math.round(i * ((1 << e) - 1));
    },
        n = function n(i, s, u, c, o) {
      var l = o ? 2 : 3,
          f = 1 / u,
          h = Math.min(1, u),
          p = l / h,
          m = Math.floor((p + 1) * 2),
          d = new Int16Array((m + 2) * s),
          y = 0;

      for (var v = 0; v < s; v++) {
        var g = (v + .5) * f + c,
            A = Math.max(0, Math.floor(g - p)),
            D = Math.min(i - 1, Math.ceil(g + p)),
            M = D - A + 1,
            $ = new Float32Array(M),
            j = new Int16Array(M),
            T = 0,
            N = 0;

        for (var x = A; x <= D; x++) {
          var k = r((x + .5 - g) * h, l);
          T += k, $[N] = k, N++;
        }

        var I = 0;

        for (var _x = 0; _x < $.length; _x++) {
          var _k = $[_x] / T;

          I += _k, j[_x] = a(_k);
        }

        j[s >> 1] += a(1 - I);
        var S = 0;

        for (; S < j.length && j[S] === 0;) {
          S++;
        }

        var V = j.length - 1;

        for (; V > 0 && j[V] === 0;) {
          V--;
        }

        var pt = A + S,
            Q = V - S + 1;
        d[y++] = pt, d[y++] = Q, d.set(j.subarray(S, V + 1), y), y += Q;
      }

      return d;
    };

    t.filters = n;
  }
}),
    Ge = rt({
  "../../node_modules/.pnpm/@rgba-image+lanczos@0.1.1/node_modules/@rgba-image/lanczos/dist/convolve.js": function node_modulesPnpmRgbaImageLanczos011Node_modulesRgbaImageLanczosDistConvolveJs(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.convolve = void 0;

    var e = 14,
        r = function r(a, n, i, s, u, c) {
      var o = 0,
          l = 0;

      for (var f = 0; f < s; f++) {
        var h = 0;

        for (var p = 0; p < u; p++) {
          var m = c[h++],
              d = o + m * 4 | 0,
              y = 0,
              v = 0,
              g = 0,
              A = 0;

          for (var D = c[h++]; D > 0; D--) {
            var M = c[h++];
            y = y + M * a[d] | 0, v = v + M * a[d + 1] | 0, g = g + M * a[d + 2] | 0, A = A + M * a[d + 3] | 0, d = d + 4 | 0;
          }

          n[l] = y + 8192 >> e, n[l + 1] = v + 8192 >> e, n[l + 2] = g + 8192 >> e, n[l + 3] = A + 8192 >> e, l = l + s * 4 | 0;
        }

        l = (f + 1) * 4 | 0, o = (f + 1) * i * 4 | 0;
      }
    };

    t.convolve = r;
  }
}),
    Ze = rt({
  "../../node_modules/.pnpm/@rgba-image+lanczos@0.1.1/node_modules/@rgba-image/lanczos/dist/index.js": function node_modulesPnpmRgbaImageLanczos011Node_modulesRgbaImageLanczosDistIndexJs(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.lanczos2 = t.lanczos = void 0;

    var e = He(),
        r = Je(),
        a = We(),
        n = Ge(),
        i = function i(c, o) {
      var l = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var f = o.width / c.width,
          h = o.height / c.height,
          p = a.filters(c.width, o.width, f, 0, l),
          m = a.filters(c.height, o.height, h, 0, l),
          d = new Uint8ClampedArray(o.width * c.height * 4);
      n.convolve(c.data, d, c.width, c.height, o.width, p), n.convolve(d, o.data, c.height, o.width, o.height, m);
    },
        s = function s(c, o) {
      var l = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var f = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var h = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : c.width - l;
      var p = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : c.height - f;
      var m = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
      var d = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
      var y = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : o.width - m;
      var v = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : o.height - d;
      if (l = l | 0, f = f | 0, h = h | 0, p = p | 0, m = m | 0, d = d | 0, y = y | 0, v = v | 0, h <= 0 || p <= 0 || y <= 0 || v <= 0) return;

      if (l === 0 && f === 0 && h === c.width && p === c.height && m === 0 && d === 0 && y === o.width && v === o.height) {
        i(c, o);
        return;
      }

      var g = r.createImage(h, p),
          A = r.createImage(y, v);
      e.copy(c, g, l, f), i(g, A), e.copy(A, o, 0, 0, A.width, A.height, m, d);
    };

    t.lanczos = s;

    var u = function u(c, o) {
      var l = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var f = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var h = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : c.width - l;
      var p = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : c.height - f;
      var m = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
      var d = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
      var y = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : o.width - m;
      var v = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : o.height - d;
      if (l = l | 0, f = f | 0, h = h | 0, p = p | 0, m = m | 0, d = d | 0, y = y | 0, v = v | 0, h <= 0 || p <= 0 || y <= 0 || v <= 0) return;

      if (l === 0 && f === 0 && h === c.width && p === c.height && m === 0 && d === 0 && y === o.width && v === o.height) {
        i(c, o, !0);
        return;
      }

      var g = r.createImage(h, p),
          A = r.createImage(y, v);
      e.copy(c, g, l, f), i(g, A, !0), e.copy(A, o, 0, 0, A.width, A.height, m, d);
    };

    t.lanczos2 = u;
  }
});

var fe = function (t) {
  return t.Bounce = "bounce", t.Normal = "normal", t;
}(fe || {}),
    Ke = ne(fe),
    he = O({
  autoplay: w(lt()),
  defaultTheme: w(b()),
  direction: w(ct([Et(1), Et(-1)])),
  hover: w(lt()),
  id: b(),
  intermission: w(U()),
  loop: w(ct([lt(), U()])),
  playMode: w(Ke),
  speed: w(U()),
  themeColor: w(b())
}),
    Ye = O({
  animations: Y(b()),
  id: b()
}),
    Xe = O({
  activeAnimationId: w(b()),
  animations: Y(he),
  author: w(b()),
  custom: w(zt(b(), re())),
  description: w(b()),
  generator: w(b()),
  keywords: w(b()),
  revision: w(U()),
  themes: w(Y(Ye)),
  states: w(Y(b())),
  version: w(b())
}),
    Qe = ae(he, ["id"]),
    G = O({
  state: b()
}),
    tr = G,
    er = X([G, O({
  ms: U()
})]),
    rr = X([G, O({
  count: U()
})]),
    nr = G,
    ar = G,
    ir = G,
    sr = X([G, O({
  threshold: w(Y(U([ht(0), ft(1)])))
})]),
    or = O({
  onAfter: w(er),
  onClick: w(tr),
  onComplete: w(ir),
  onEnter: w(rr),
  onMouseEnter: w(nr),
  onMouseLeave: w(ar),
  onShow: w(sr)
}),
    ur = X([Qe, O({
  playOnScroll: w(Ot([U([ht(0), ft(1)]), U([ht(0), ft(1)])])),
  segments: w(ct([Ot([U(), U()]), b()]))
})]);

X([or, O({
  animationId: w(b()),
  playbackSettings: ur
})]);
var hr = {
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  bmp: "image/bmp",
  svg: "image/svg+xml",
  webp: "image/webp",
  mpeg: "audio/mpeg",
  mp3: "audio/mp3"
},
    se = {
  jpeg: [255, 216, 255],
  png: [137, 80, 78, 71, 13, 10, 26, 10],
  gif: [71, 73, 70],
  bmp: [66, 77],
  webp: [82, 73, 70, 70, 87, 69, 66, 80],
  svg: [60, 63, 120],
  mp3: [73, 68, 51, 3, 0, 0, 0, 0],
  mpeg: [73, 68, 51, 3, 0, 0, 0, 0]
};

var dr = function dr(t) {
  var e = null,
      r = [];
  if (!t) return null;
  var a = t.substring(t.indexOf(",") + 1);
  typeof window > "u" ? e = Buffer.from(a, "base64").toString("binary") : e = atob(a);
  var n = new Uint8Array(e.length);

  for (var i = 0; i < e.length; i += 1) {
    n[i] = e.charCodeAt(i);
  }

  r = Array.from(n.subarray(0, 8));

  var _loop2 = function _loop2(_i2) {
    var s = se[_i2];
    if (s && r.every(function (u, c) {
      return u === s[c];
    })) return {
      v: hr[_i2]
    };
  };

  for (var _i2 in se) {
    var _ret = _loop2(_i2);

    if (typeof _ret === "object") return _ret.v;
  }

  return null;
};

var St = /*#__PURE__*/function (_Error2) {
  _inherits(St, _Error2);

  var _super2 = _createSuper(St);

  function St(t, e) {
    var _this2;

    _classCallCheck(this, St);

    _this2 = _super2.call(this, t), $e(_assertThisInitialized(_this2), "code"), _this2.name = "[dotlottie-js]", _this2.code = e;
    return _this2;
  }

  return _createClass(St);
}( /*#__PURE__*/_wrapNativeSuper(Error));

function de(t) {
  var e;
  if (typeof window > "u") e = Buffer.from(t).toString("base64");else {
    var a = Array.prototype.map.call(t, function (n) {
      return String.fromCharCode(n);
    }).join("");
    e = window.btoa(a);
  }
  return "data:".concat(dr(e), ";base64,").concat(e);
}

function oe(t) {
  return "w" in t && "h" in t && !("xt" in t) && "p" in t;
}

function dt(t) {
  return !("h" in t) && !("w" in t) && "p" in t && "e" in t && "u" in t && "id" in t;
}

function nt(_x2) {
  return _nt.apply(this, arguments);
}

function _nt() {
  _nt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
    var e,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            e = _args.length > 1 && _args[1] !== undefined ? _args[1] : function () {
              return !0;
            };

            if (t instanceof Uint8Array) {
              _context.next = 3;
              break;
            }

            throw new St("DotLottie not found", "INVALID_DOTLOTTIE");

          case 3:
            _context.next = 5;
            return new Promise(function (a, n) {
              te(t, {
                filter: e
              }, function (i, s) {
                i && n(i), a(s);
              });
            });

          case 5:
            return _context.abrupt("return", _context.sent);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _nt.apply(this, arguments);
}

function Dt(_x3, _x4, _x5) {
  return _Dt.apply(this, arguments);
}

function _Dt() {
  _Dt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t, e, r) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (t instanceof Uint8Array) {
              _context2.next = 2;
              break;
            }

            throw new St("DotLottie not found", "INVALID_DOTLOTTIE");

          case 2:
            _context2.next = 4;
            return nt(t, function (n) {
              return n.name === e && (!r || r(n));
            });

          case 4:
            _context2.t0 = e;
            return _context2.abrupt("return", _context2.sent[_context2.t0]);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _Dt.apply(this, arguments);
}

function pr(_x6) {
  return _pr.apply(this, arguments);
}

function _pr() {
  _pr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t) {
    var e, a;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            e = "manifest.json";
            _context3.next = 3;
            return nt(t, function (n) {
              return n.name === e;
            });

          case 3:
            _context3.t0 = e;
            a = _context3.sent[_context3.t0];

            if (typeof a > "u") {
              _context3.next = 7;
              break;
            }

            return _context3.abrupt("return", JSON.parse(W(a, !1)));

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _pr.apply(this, arguments);
}

function mr(_x7) {
  return _mr.apply(this, arguments);
}

function _mr() {
  _mr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(t) {
    var e, r;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (t instanceof Uint8Array) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return", {
              success: !1,
              error: "DotLottie not found"
            });

          case 2:
            _context4.next = 4;
            return pr(t);

          case 4:
            e = _context4.sent;

            if (!(typeof e > "u")) {
              _context4.next = 7;
              break;
            }

            return _context4.abrupt("return", {
              success: !1,
              error: "Invalid .lottie file, manifest.json is missing"
            });

          case 7:
            r = ie(Xe, e);
            return _context4.abrupt("return", r.success ? {
              success: !0
            } : {
              success: !1,
              error: "Invalid .lottie file, manifest.json structure is invalid, ".concat(JSON.stringify(ee(r.error).nested, null, 2))
            });

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _mr.apply(this, arguments);
}

function Kr(_x8) {
  return _Kr.apply(this, arguments);
}

function _Kr() {
  _Kr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(t) {
    var e, r;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            e = new Uint8Array(t);
            _context5.next = 3;
            return mr(e);

          case 3:
            r = _context5.sent;

            if (!r.error) {
              _context5.next = 6;
              break;
            }

            throw new St(r.error, "INVALID_DOTLOTTIE");

          case 6:
            return _context5.abrupt("return", e);

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _Kr.apply(this, arguments);
}

function vr(_x9, _x10) {
  return _vr.apply(this, arguments);
}

function _vr() {
  _vr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(t, e) {
    var r, a, n, i, s;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return nt(t, function (n) {
              var i = n.name.replace("audio/", "");
              return n.name.startsWith("audio/") && (!e || e(_objectSpread(_objectSpread({}, n), {}, {
                name: i
              })));
            });

          case 2:
            r = _context6.sent;
            a = {};

            for (n in r) {
              i = r[n];

              if (i instanceof Uint8Array) {
                s = n.replace("audio/", "");
                a[s] = de(i);
              }
            }

            return _context6.abrupt("return", a);

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _vr.apply(this, arguments);
}

function yr(_x11, _x12) {
  return _yr.apply(this, arguments);
}

function _yr() {
  _yr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(t, e) {
    var n, r, _i3, _Object$entries2, _Object$entries2$_i, i, s, _iterator12, _step12, u, c, a, _iterator13, _step13, _step13$value, _i4, _s, _u, _iterator14, _step14, _c, o, _iterator15, _step15, l;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            r = new Map();

            for (_i3 = 0, _Object$entries2 = Object.entries(e); _i3 < _Object$entries2.length; _i3++) {
              _Object$entries2$_i = _slicedToArray(_Object$entries2[_i3], 2), i = _Object$entries2$_i[0], s = _Object$entries2$_i[1];
              _iterator12 = _createForOfIteratorHelper(s.assets || []);

              try {
                for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                  u = _step12.value;

                  if (dt(u)) {
                    c = u.p;
                    r.has(c) || r.set(c, new Set()), (n = r.get(c)) == null || n.add(i);
                  }
                }
              } catch (err) {
                _iterator12.e(err);
              } finally {
                _iterator12.f();
              }
            }

            _context7.next = 4;
            return vr(t, function (i) {
              return r.has(i.name);
            });

          case 4:
            a = _context7.sent;
            _iterator13 = _createForOfIteratorHelper(r);

            try {
              for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                _step13$value = _slicedToArray(_step13.value, 2), _i4 = _step13$value[0], _s = _step13$value[1];
                _u = a[_i4];

                if (_u) {
                  _iterator14 = _createForOfIteratorHelper(_s);

                  try {
                    for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                      _c = _step14.value;
                      o = e[_c];
                      _iterator15 = _createForOfIteratorHelper((o == null ? void 0 : o.assets) || []);

                      try {
                        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                          l = _step15.value;
                          dt(l) && l.p === _i4 && (l.p = _u, l.u = "", l.e = 1);
                        }
                      } catch (err) {
                        _iterator15.e(err);
                      } finally {
                        _iterator15.f();
                      }
                    }
                  } catch (err) {
                    _iterator14.e(err);
                  } finally {
                    _iterator14.f();
                  }
                }
              }
            } catch (err) {
              _iterator13.e(err);
            } finally {
              _iterator13.f();
            }

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _yr.apply(this, arguments);
}

function gr(_x13, _x14) {
  return _gr.apply(this, arguments);
}

function _gr() {
  _gr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(t, e) {
    var r, a, n, i, s;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return nt(t, function (n) {
              var i = n.name.replace("images/", "");
              return n.name.startsWith("images/") && (!e || e(_objectSpread(_objectSpread({}, n), {}, {
                name: i
              })));
            });

          case 2:
            r = _context8.sent;
            a = {};

            for (n in r) {
              i = r[n];

              if (i instanceof Uint8Array) {
                s = n.replace("images/", "");
                a[s] = de(i);
              }
            }

            return _context8.abrupt("return", a);

          case 6:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _gr.apply(this, arguments);
}

function _r(_x15, _x16) {
  return _r2.apply(this, arguments);
}

function _r2() {
  _r2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(t, e) {
    var n, r, _i5, _Object$entries3, _Object$entries3$_i, i, s, _iterator16, _step16, u, c, a, _iterator17, _step17, _step17$value, _i6, _s2, _u2, _iterator18, _step18, _c2, o, _iterator19, _step19, l;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            r = new Map();

            for (_i5 = 0, _Object$entries3 = Object.entries(e); _i5 < _Object$entries3.length; _i5++) {
              _Object$entries3$_i = _slicedToArray(_Object$entries3[_i5], 2), i = _Object$entries3$_i[0], s = _Object$entries3$_i[1];
              _iterator16 = _createForOfIteratorHelper(s.assets || []);

              try {
                for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                  u = _step16.value;

                  if (oe(u)) {
                    c = u.p;
                    r.has(c) || r.set(c, new Set()), (n = r.get(c)) == null || n.add(i);
                  }
                }
              } catch (err) {
                _iterator16.e(err);
              } finally {
                _iterator16.f();
              }
            }

            _context9.next = 4;
            return gr(t, function (i) {
              return r.has(i.name);
            });

          case 4:
            a = _context9.sent;
            _iterator17 = _createForOfIteratorHelper(r);

            try {
              for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                _step17$value = _slicedToArray(_step17.value, 2), _i6 = _step17$value[0], _s2 = _step17$value[1];
                _u2 = a[_i6];

                if (_u2) {
                  _iterator18 = _createForOfIteratorHelper(_s2);

                  try {
                    for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                      _c2 = _step18.value;
                      o = e[_c2];
                      _iterator19 = _createForOfIteratorHelper((o == null ? void 0 : o.assets) || []);

                      try {
                        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                          l = _step19.value;
                          oe(l) && l.p === _i6 && (l.p = _u2, l.u = "", l.e = 1);
                        }
                      } catch (err) {
                        _iterator19.e(err);
                      } finally {
                        _iterator19.f();
                      }
                    }
                  } catch (err) {
                    _iterator18.e(err);
                  } finally {
                    _iterator18.f();
                  }
                }
              }
            } catch (err) {
              _iterator17.e(err);
            } finally {
              _iterator17.f();
            }

          case 7:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _r2.apply(this, arguments);
}

function Yr(_x17, _x18) {
  return _Yr.apply(this, arguments);
}

function _Yr() {
  _Yr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(t, e) {
    var _ref4,
        r,
        a,
        n,
        i,
        s,
        u,
        _args10 = arguments;

    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _ref4 = _args10.length > 2 && _args10[2] !== undefined ? _args10[2] : {}, r = _ref4.inlineAssets;
            a = _args10.length > 3 ? _args10[3] : undefined;
            n = "animations/".concat(e, ".json");
            _context10.next = 5;
            return Dt(t, n, a);

          case 5:
            i = _context10.sent;

            if (!(typeof i > "u")) {
              _context10.next = 8;
              break;
            }

            return _context10.abrupt("return");

          case 8:
            s = JSON.parse(W(i, !1));

            if (r) {
              _context10.next = 11;
              break;
            }

            return _context10.abrupt("return", s);

          case 11:
            u = _defineProperty({}, e, s);
            _context10.next = 14;
            return _r(t, u);

          case 14:
            _context10.next = 16;
            return yr(t, u);

          case 16:
            return _context10.abrupt("return", s);

          case 17:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _Yr.apply(this, arguments);
}

function Xr(_x19, _x20, _x21) {
  return _Xr.apply(this, arguments);
}

function _Xr() {
  _Xr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(t, e, r) {
    var a, n;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            a = "themes/".concat(e, ".lss");
            _context11.next = 3;
            return Dt(t, a, r);

          case 3:
            n = _context11.sent;

            if (typeof n > "u") {
              _context11.next = 6;
              break;
            }

            return _context11.abrupt("return", W(n, !1));

          case 6:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _Xr.apply(this, arguments);
}

function Qr(_x22, _x23) {
  return _Qr.apply(this, arguments);
}

function _Qr() {
  _Qr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(t, e) {
    var r, a, n, i, s;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            r = {};
            _context12.next = 3;
            return nt(t, function (n) {
              var i = n.name.replace("states/", "").replace(".json", "");
              return n.name.startsWith("states/") && (!e || e(_objectSpread(_objectSpread({}, n), {}, {
                name: i
              })));
            });

          case 3:
            a = _context12.sent;

            for (n in a) {
              i = a[n];

              if (i instanceof Uint8Array) {
                s = n.replace("states/", "").replace(".json", "");
                r[s] = W(i, !1);
              }
            }

            return _context12.abrupt("return", r);

          case 6:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _Qr.apply(this, arguments);
}

function tn(_x24, _x25, _x26) {
  return _tn.apply(this, arguments);
}

function _tn() {
  _tn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(t, e, r) {
    var a, n;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            a = "states/".concat(e, ".json");
            _context13.next = 3;
            return Dt(t, a, r);

          case 3:
            n = _context13.sent;
            return _context13.abrupt("return", typeof n > "u" ? void 0 : JSON.parse(W(n, !1)));

          case 5:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _tn.apply(this, arguments);
}

Re(Ze());

function sn(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "dotLottie-common";
  return new Error("[".concat(e, "]: ").concat(t));
}

function on(t) {
  var _console;

  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "dotLottie-common";

  for (var _len = arguments.length, r = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    r[_key - 2] = arguments[_key];
  }

  (_console = console).error.apply(_console, ["[".concat(e, "]:"), t].concat(r));
}

function un(t) {
  var _console2;

  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "dotLottie-common";

  for (var _len2 = arguments.length, r = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    r[_key2 - 2] = arguments[_key2];
  }

  (_console2 = console).warn.apply(_console2, ["[".concat(e, "]:"), t].concat(r));
}

function ln() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var e = t.trim(),
      r = e.lastIndexOf("/"),
      a = e.substring(r + 1),
      n = a.indexOf(".");
  return n !== -1 ? a.substring(0, n) : a;
}

function Vr(t) {
  return ["v", "ip", "op", "layers", "fr", "w", "h"].every(function (r) {
    return Object.prototype.hasOwnProperty.call(t, r);
  });
}

function cn(t) {
  var e = t.assets;
  return e ? e.some(function (r) {
    return dt(r);
  }) : !1;
}

function fn(t) {
  try {
    var e = JSON.parse(t);
    return Vr(e);
  } catch (_unused2) {
    return !1;
  }
}

function hn(t, e) {
  var r = Object.keys(t).find(function (a) {
    return t[a] === e;
  });
  if (r === void 0) throw new Error("Value not found in the object.");
  return r;
}

export { Qe as a, pr as b, Kr as c, Yr as d, Xr as e, Qr as f, tn as g, sn as h, on as i, un as j, ln as k, Vr as l, cn as m, fn as n, hn as o };